export class Profile {
  private _profile: any;

  // Expects profile to be the profile returned from Auth0.
  constructor(profile: any) {
    this._profile = profile;
  }

  get raw(): any {
    return this._profile;
  }

  get email(): string {
    return this._profile.email;
  }

  get picture(): string {
    return this._profile.picture;
  }

  get nickname(): string {
    return this._profile.nickname;
  }

  get userId(): string {
    return this._profile.sub;
  }

  get given_name(): string {
    return this._profile.given_name;
  }

  get full_name(): string {
    return this._profile.given_name + ' ' + this._profile.family_name;
  }

  get isUsingSSO(): boolean {
    // TODO: Find a better way to pull in the domain.
    return this._profile['https://lineupteams.com/connectionstrategy'] === 'samlp';
  }
}
